'use strict';

const extensions = {
    jpeg: 'jpeg',
    jpg: 'jpg',
    png: 'png',
    gif: 'gif',
    heif: 'heif', //apple still photo
    heic: 'heic',
    plist: 'plist', //apple's way of saving edited photos on iOS 13+
    webp: 'webp',
};

const mimetypes = {
    jpg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    heic: 'image/heic',
    heicSequence: 'image/heic-sequence',
    webp: 'image/webp',
};

const webImageFormats = 'image/png, image/jpeg, image/gif, image/webp';

export { extensions as EXTENSIONS, mimetypes as MIMETYPES, webImageFormats as WEB_IMAGE_FORMATS };
